import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import logo from "../assets/trimo-logo.png";

export default function Footer() {
  const { t, pick } = useLang();

  const cols = [
    {
      title: t("footer_product"),
      links:
        pick({ es: ["Funciones", "Precios", "Clip Studio", "API"], en: ["Features", "Pricing", "Clip Studio", "API"] }),
    },
    {
      title: t("footer_company"),
      links:
        pick({ es: ["Sobre nosotros", "Blog", "Contacto", "Afiliados"], en: ["About", "Blog", "Contact", "Affiliates"] }),
    },
    {
      title: t("footer_legal"),
      links:
        pick({ es: ["Privacidad", "Términos", "Cookies"], en: ["Privacy", "Terms", "Cookies"] }),
    },
  ];

  return (
    <footer className="border-t border-white/10 pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-5">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <img src={logo} alt="Vitled" className="h-8 w-8 rounded-lg" />
              <span className="text-xl font-bold">
                Vit<span className="text-yellow-400">led</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-zinc-400 max-w-xs leading-relaxed">{t("footer_tagline")}</p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href="#" className="text-sm text-zinc-400 hover:text-yellow-400 transition-colors">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-500">
            © {new Date().getFullYear()} Vitled — {t("footer_rights")}
          </p>
          <p className="text-xs text-zinc-500">Made with AI for creators.</p>
        </div>
      </div>
    </footer>
  );
}
